export default __webpack_public_path__ + "static/media/my529_logo_Utah_tagline.dc40f2b3.jpg";